<template>
    <div>
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="330px">
                <v-card>
                    <v-card-title>
                        <span
                            class="headline">
                            {{ $vuetify.lang.t('$vuetify.successModal.congratulation') }} !!
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                {{ this.$store.state.successModalMsg }}
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog = false">
                            {{ $vuetify.lang.t('$vuetify.successModal.close') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'SuccessModal',

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            dialog: this.value
        }
    },

    watch: {
        value (newValue, oldValue) {
            this.dialog = newValue
        },
        dialog (newValue, oldValue) {
            if (newValue === false) {
                this.$store.dispatch('setSuccessModalShow', newValue)
                this.$store.dispatch('setSuccessModalMsg', '')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
